export class MenuScroll {
	constructor(header) {
		this.header        = header;
		this.prevScrollpos = window.pageYOffset;

		this.initAddListener();
	}

	initAddListener() {
		window.addEventListener('scroll', this.eventScroll.bind(this));
	}

	eventScroll() {
		this.currentScrollPos = window.pageYOffset;

		if(window.pageYOffset > 100) {
			if(this.currentScrollPos >= 100) {
				if(this.prevScrollpos > this.currentScrollPos) {
					this.header.style.top = '0';
				} else {
					this.header.style.top = '-' + this.header.clientHeight + 'px';
				}
				this.prevScrollpos = this.currentScrollPos;
			}
		} else {
			this.header.style.top = '0';
		}
	}
}